import { render, staticRenderFns } from "./cursos-detalles-detalles.vue?vue&type=template&id=07b108df&scoped=true&"
import script from "./cursos-detalles-detalles.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles-detalles.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-detalles-detalles.vue?vue&type=style&index=0&id=07b108df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b108df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
